// src/repos/animalRepo.js
import { db } from '@/db/db';

export const helpRepo = {
  // 오늘자 캐시 조회
  async listByDate(dayStr) {
    return db.help.filter(row => row.update_date === dayStr).toArray();
  },

  // 오늘자(category) 데이터만 교체 (지우고 새로 넣기)
  async replaceHelp(rows) {
    return db.transaction('rw', db.help, async () => {
      await db.help.clear();                              // ← 카테고리+오늘자만 삭제

      await db.help.bulkPut(rows);             // ← 한 번에 저장
    });
  },
};